<span class="list__item-text">
	<span
		*ngIf="heading"
		class="c-list__item-heading"
	>
		{{ heading }}
	</span>
	<ng-content></ng-content>
</span>
